import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

const CommunityPage = () => {
  return (
    <Container maxWidth="lg">
      <Box mt={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Community
        </Typography>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="body1">
            Community features coming soon...
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default CommunityPage; 